import { useState } from "react";

// Round Bull emblem from Brothers Coffee — falls back to inline SVG if the CDN URL fails
const LOGO_URL = "https://cdn1.zohoecommerce.com/Stain%20only%20bull.png?v=1772534949&storefront_domain=www.brotherscoffee.co.za";

export function BullMark({ className = "w-10 h-10", accent = "#C68A4C", ink = "#1F1610" }) {
  const [failed, setFailed] = useState(false);
  if (!failed) {
    return (
      <img
        src={LOGO_URL}
        alt="DocHub"
        className={`${className} object-contain`}
        onError={() => setFailed(true)}
        loading="eager"
      />
    );
  }
  return (
    <svg viewBox="0 0 64 64" className={className} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="32" cy="32" r="30" fill={ink} />
      <path d="M14 22 Q20 12 24 20 Q28 18 32 20 Q36 18 40 20 Q44 12 50 22 Q46 24 42 22 L40 26 L24 26 L22 22 Q18 24 14 22 Z" fill={accent} />
      <path d="M20 28 L44 28 L42 40 Q32 50 22 40 Z" fill={accent} />
      <circle cx="27" cy="34" r="2" fill={ink} />
      <circle cx="37" cy="34" r="2" fill={ink} />
      <ellipse cx="32" cy="42" rx="3" ry="2" fill={ink} />
    </svg>
  );
}
